<template>
  <transition name="el-fade-in">
    <div class="full_height">
      <el-container class="cn1">
        <el-header>
          <HeadBar />
        </el-header>
        <el-container class="cn2">
          <el-aside width="15%" class="sidebar">
            <SideBar />
          </el-aside>
          <el-main>
            <!-- 滚动轴修饰 -->
            <el-scrollbar style="height: 98%">
              <!-- 过渡动画 -->
              <transition name="el-fade-in">
                <router-view> </router-view>
              </transition>
            </el-scrollbar>
            <div style="height: 2%"></div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </transition>
</template>

<script>
// 导入页面组件
import HeadBar from "@/components/HeadBar.vue";
import SideBar from "@/components/SideBar.vue";

// 导出后该页面也能被当组件使用
export default {
  data() {
    return {
      msg: "asdasd",
    };
  },
  name: "Home",
  components: {
    HeadBar,
    SideBar,
  },
};
</script>

<style scoped lang="scss">
.el-header {
  // background: rgb(2, 70, 109);
  background: rgb(31, 43, 64);
  padding-left: 2;
  padding-right: 2;
  height: 8%;
}

.el-main {
  height: 100%;
  // background: rgba(238, 238, 238, 0.575);
  background: rgb(239, 241, 244);
}

.cn1 {
  height: 100%;
}

.cn2 {
  height: 92%;
}

.el-aside {
  border-right: 1px solid gainsboro;
}

.sidebar {
  background-color: rgb(46, 63, 86);
}
</style>